export default __webpack_public_path__ + "static/media/backgroundLogin.6908b2cc.png";